import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Button, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import HiveOutlinedIcon from '@mui/icons-material/HiveOutlined';
import ScatterPlotIcon from '@mui/icons-material/ScatterPlot';
import HighlightAltOutlinedIcon from '@mui/icons-material/HighlightAltOutlined';
import LoupeIcon from '@mui/icons-material/Loupe';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import GeneListDrawer from '../Gene/GeneListDrawer';
import FactorViewDrawer from '../Factor/FactorViewDrawer';
import BurgerMenuPane from './BurgerMenuPane';
import InspectDrawer from '../Inspect/InspectDrawer';
import ROIDrawer from '../ROI/ROIDrawer';
import ViewState from './ViewState';
import AuthDrawer from '../Auth/AuthDrawer';

function NavBar({ layerProps }) {
  // State to manage the visibility of drawers
  const [isGeneListDrawerOpen, setGeneListDrawerOpen] = useState(false);
  const [isFactorViewDrawerOpen, setFactorViewDrawerOpen] = useState(false);
  const [isBurgerMenuOpen, setBurgerMenuOpen] = useState(false);
  const [isInspectDrawerOpen, setInspectDrawerOpen] = useState(false);
  const [isROIDrawerOpen, setROIDrawerOpen] = useState(false);
  const [isAuthDrawerOpen, setAuthDrawerOpen] = useState(false);

  const handleClickTitle = () => {
    // remove the query params when clicking title
    const location = window.location;
    const queryParams = location.search;
    if (queryParams) {
      const pathname = location.pathname;
      window.history.pushState({}, '', pathname);
    }
  }

  return (
    <AppBar position="fixed" className="navbar-custom">
      <Toolbar className="toolbar-custom">
        <div className="navbar-left">
          <div className="title-area">
            <IconButton
              edge="start"
              aria-label="menu"
              onClick={() => setBurgerMenuOpen(!isBurgerMenuOpen)}
            >
              <MenuIcon className="burgerMenu" />
            </IconButton>
            <Typography variant="h6" noWrap>
              <div
                style={{ cursor: 'pointer' }}
                onClick={handleClickTitle}
              >
                <b>CartoScope</b>
              </div>
            </Typography>
          </div>
          <ViewState layerProps={layerProps} />
        </div>
        <div className="topmenu-area">
          <Button
            className={`topmenu-button ${isInspectDrawerOpen ? 'active' : ''}`}
            onClick={() => {
              setInspectDrawerOpen(prevState => !prevState);
              setROIDrawerOpen(false);
              setGeneListDrawerOpen(false);
              setFactorViewDrawerOpen(false);
              setAuthDrawerOpen(false);
            }}
          >
            <LoupeIcon />
            Inspect
          </Button>
          <Button
            className={`topmenu-button ${isROIDrawerOpen ? 'active' : ''}`}
            onClick={() => {
              setROIDrawerOpen(prevState => !prevState);
              setInspectDrawerOpen(false);
              setGeneListDrawerOpen(false);
              setFactorViewDrawerOpen(false);
              setAuthDrawerOpen(false);
            }}
          >
            <HighlightAltOutlinedIcon />
            ROI Analysis
          </Button>
          <Button
            className={`topmenu-button ${isGeneListDrawerOpen ? 'active' : ''}`}
            onClick={() => {
              setGeneListDrawerOpen(prevState => !prevState);
              setInspectDrawerOpen(false);
              setROIDrawerOpen(false);
              setFactorViewDrawerOpen(false);
              setAuthDrawerOpen(false);
            }}
          >
            <ScatterPlotIcon />
            Gene List
          </Button>
          <Button
            className={`topmenu-button ${isFactorViewDrawerOpen ? 'active' : ''}`}
            onClick={() => {
              setFactorViewDrawerOpen(prevState => !prevState);
              setInspectDrawerOpen(false);
              setROIDrawerOpen(false);
              setGeneListDrawerOpen(false);
              setAuthDrawerOpen(false);
            }}
          >
            <HiveOutlinedIcon />
            Factor View
          </Button>
          <Button
            className={`topmenu-button ${isAuthDrawerOpen ? 'active' : ''}`}
            onClick={() => {
              setAuthDrawerOpen(prevState => !prevState);
              setFactorViewDrawerOpen(false);
              setInspectDrawerOpen(false);
              setROIDrawerOpen(false);
              setGeneListDrawerOpen(false);
            }}
          >
            <AccountCircleIcon />
            User
          </Button>

        </div>
      </Toolbar>
      {isBurgerMenuOpen && <BurgerMenuPane />}

      <GeneListDrawer
        isOpen={isGeneListDrawerOpen}
      />
      <FactorViewDrawer
        isOpen={isFactorViewDrawerOpen}
      />
      <InspectDrawer
        isOpen={isInspectDrawerOpen}
        layerProps={layerProps}
      />
      <ROIDrawer
        isOpen={isROIDrawerOpen}
      />
      <AuthDrawer
        isOpen={isAuthDrawerOpen}
      />
    </AppBar>
  );
}

export default NavBar;
